module.exports = __webpack_public_path__ + "2b0edbf853b5fd471b79fb6bd36f7202.MP3";